{
  "title": "Payment Instructions",
  "body": "Configure the amount, frequency, and destination for your {{fundPrefix}} withdrawals to suit your financial needs.",
  "paymentFrequency": "Payment frequency:",
  "startDate": "Start date:",
  "depositTo": "Deposit to:",
  "modal": {
    "title": "Set up payment instructions",
    "subtitle": {
      "1": "A {{fundPrefix}} provides steady retirement income, allowing for flexible, incremental withdrawals based on the frequency and amount of your choosing, so long as it meets the ",
      "2": "Minimum Annual Withdrawal ",
      "3": "amount."
    },
    "ageSelectLabel": "Select age for minimum withdrawal calculation",
    "myAgeSelectOption": "Use my age ({{age}})",
    "mySpousesAgeSelectOption": "Use spouses age ({{age}})",
    "totalAnnualWithdrawalLabel": "Total annual withdrawal",
    "totalAnnualWithdrawalMinimumAmountOption": "Minimum allowable amount",
    "totalAnnualWithdrawalCustomAmountOption": "Custom amount",
    "totalAnnualWithdrawalMaximumAmountOption": "Maximum allowable amount",
    "amountLabel": "Amount",
    "paymentFrequencyLabel": "Payment Frequency",
    "ANNUALLY": "Annually",
    "SEMI_ANNUALLY": "Semi Annually",
    "QUARTERLY": "Quarterly",
    "MONTHLY": "Monthly",
    "withdrawalTypeLabel": "Withdrawal type",
    "withdrawalTypeNetOption": "Net",
    "withdrawalTypeGrossOption": "Gross",
    "startDateLabel": "Start date",
    "note1": "The payment instructions will be executed as indicated. You can always change your payment preferences. Note, all withdrawals are fully taxable as income in the year withdrawn, and amounts above the annual minimum payment will incur withholding taxes as well.",
    "note2": "* Minimum withdrawal for the year is an estimate based on the age selected and is subject to change.",
    "subAccountLabel": "Sub-account"
  },
  "lifTitle": "life income fund",
  "rifTitle": "retirement income fund",
  "totalAnnualWithdrawal": "Total annual withdrawal:",
  "amount": "Amount:",
  "invalidSubAccountToastMessage": "Requires a valid SubAccount in ACTIVE or AWAITING_REVIEW state"
}
